import C from "@/components/sidebar/EmptyItem.module.css";

import { MaskIcon } from "@/components/icon/MaskIcon.tsx";
import { Trans } from "@lingui/react/macro";
import type { ReactNode } from "react";

export function EmptyItem({ children, icon }: { children: ReactNode; icon?: string }) {
    return (
        <div className={C.EmptyItem}>
            {icon ? (
                <div className={C.EmptyItemIcon}>
                    <MaskIcon className={`${icon} size-5rem`} />
                </div>
            ) : null}
            {children}
        </div>
    );
}

export function NoResults() {
    return (
        <EmptyItem icon="jp-cactus-icon">
            <Trans>No results found</Trans>
        </EmptyItem>
    );
}
